export class Paginador {
    constructor (public tamanhoDisplay: number, public tamanhoItem: number, public totalPaginas: number) { }

    public paginaAtual: number = 1;
    public qtdItensPagina = parseInt(Number(this.tamanhoDisplay / this.tamanhoItem).toString());
    
    public calcularTotalPaginas(qtdItens: number) {
        this.totalPaginas = Math.ceil(qtdItens / this.qtdItensPagina);
    }
    
    public paginar(lista: any[]): any[] {
        const inicio = (this.paginaAtual - 1) * this.qtdItensPagina;
        const fim = inicio + this.qtdItensPagina;
        
        return lista.slice(inicio, fim);
    }
}